
import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getCompletedOrdersRequest, getCompletedOrdersRequestError, getCompletedOrdersRequestSuccess } from "../../slices/Supplier/GetCompletdOrdersSlice";

export const GetCompletedOrdersApi = (data) => async (dispatch) => {

    const queryParams = new URLSearchParams(data).toString();

    const urlWithParams = `${endpoints.getSupplierOrders}?${queryParams}`;

    try {
        dispatch(getCompletedOrdersRequest());
        axiosInstance({
            method: "GET",
            url: urlWithParams,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getCompletedOrdersRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getCompletedOrdersRequestError(_error));
            });
    } catch (error) {
    }
};
